import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import CopilotDrawer from "@/components/ai/CopilotDrawer";
import { CommandPalette } from "@/components/CommandPalette";
import { cn } from "@/lib/utils";

export default function AppShell() {
  const [copilot, setCopilot] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const [cmdOpen, setCmdOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCmdOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* mobile sidebar */}
      <div className={cn("fixed inset-0 z-50 lg:hidden", mobileNav ? "" : "pointer-events-none")}>
        <div onClick={() => setMobileNav(false)}
          className={cn("absolute inset-0 bg-black/50 transition-opacity", mobileNav ? "opacity-100" : "opacity-0")} />
        <div className={cn("absolute left-0 top-0 h-full transition-transform duration-300", mobileNav ? "translate-x-0" : "-translate-x-full")}>
          <Sidebar onNavigate={() => setMobileNav(false)} />
        </div>
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onOpenCopilot={() => setCopilot(true)} onOpenSidebar={() => setMobileNav(true)} onOpenPalette={() => setCmdOpen(true)} />
        <main className="careiq-scroll flex-1 overflow-y-auto px-4 py-6 sm:px-6 lg:px-8">
          <Outlet context={{ openCopilot: () => setCopilot(true) }} />
        </main>
      </div>

      <CopilotDrawer open={copilot} onClose={() => setCopilot(false)} />
      <CommandPalette open={cmdOpen} onOpenChange={setCmdOpen} onOpenCopilot={() => setCopilot(true)} />
    </div>
  );
}
